import * as React from 'react';
import { colors } from '@styleseat/brand';

type FireIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const FireIcon = ({
  width = 12,
  height = 15,
  color = colors.sunshine,
  ...restProps
}: FireIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.45043 7.68664C5.81472 7.17535 5.77407 6.63686 5.52147 5.66823C5.02189 3.75255 5.22082 2.70255 6.94305 1.45944L7.78363 0.852699L7.98695 1.86926C8.20302 2.94961 8.55785 3.6178 9.46894 4.90309C9.50514 4.95415 9.50514 4.95415 9.5415 5.00543C10.8539 6.85694 11.3332 7.97308 11.3332 10C11.3332 12.4589 8.84746 14.6667 5.99989 14.6667C3.15216 14.6667 0.666558 12.4592 0.666558 10C0.666558 9.95403 0.666605 9.95543 0.658817 9.7523C0.59858 8.1812 0.889098 6.95158 2.0646 5.62391C2.31297 5.34339 2.59528 5.07378 2.91298 4.8158L3.6143 4.24631L3.95167 5.08438C4.20094 5.70364 4.49302 6.19044 4.82296 6.54767C5.10241 6.85023 5.30972 7.23071 5.45043 7.68664Z"
      fill={color}
    />
  </svg>

);

export default FireIcon;
